// @ts-nocheck
import { SearchPageClient } from "@/components/search/SearchPageClient"
export default function SearchPage() {
  return <div className="container-app py-4"><SearchPageClient /></div>
}